<div class="page">
  <div class="page-head">
    <div>
      <h2>{{ pageTitle() || 'Message Catalog' }}</h2>
      <p>Reference for every messaging channel &amp; message type — what it is and how the enable/disable rules work.
        Turn each on/off per client (Client → Messaging) or per partner (Messaging).</p>
    </div>
  </div>

  <div class="rule-note">
    <i class="pi pi-info-circle"></i>
    A message sends only if <b>both</b> its channel <b>and</b> its type are enabled for the client/partner.
    If <b>all channels</b> are disabled, <b>SMS</b> is sent automatically (never fully silent).
    Business events are de-duplicated so the same event never sends twice.
  </div>

  <div class="card">
    <div class="section-title"><i class="pi pi-sitemap"></i> Channels (how it's delivered)</div>
    <p-table [value]="channels()" [loading]="loading()" styleClass="p-datatable-sm" dataKey="id">
      <ng-template pTemplate="header">
        <tr><th style="width:150px">Channel</th><th style="width:110px">Key</th><th>What it is</th><th>How it works</th></tr>
      </ng-template>
      <ng-template pTemplate="body" let-r>
        <tr>
          <td><p-tag [value]="r.name" severity="info" /></td>
          <td class="mono">{{ r.itemKey }}</td>
          <td>{{ r.description }}</td>
          <td class="muted">{{ r.howItWorks }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="4"><div class="state"><i class="pi pi-inbox"></i><p>No channels.</p></div></td></tr>
      </ng-template>
    </p-table>
  </div>

  <div class="card" style="margin-top:16px">
    <div class="section-title"><i class="pi pi-tags"></i> Message types (which kind of message)</div>
    <p-table [value]="types()" [loading]="loading()" styleClass="p-datatable-sm" dataKey="id">
      <ng-template pTemplate="header">
        <tr><th style="width:190px">Message type</th><th style="width:150px">Key</th><th>What it is</th><th>How it works</th></tr>
      </ng-template>
      <ng-template pTemplate="body" let-r>
        <tr>
          <td><span class="name">{{ r.name }}</span></td>
          <td class="mono">{{ r.itemKey }}</td>
          <td>{{ r.description }}</td>
          <td class="muted">{{ r.howItWorks }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="4"><div class="state"><i class="pi pi-inbox"></i><p>No message types.</p></div></td></tr>
      </ng-template>
    </p-table>
  </div>
</div>
